import { Link } from "react-router-dom";

import Logo from "../../../assets/images/twlogo.svg";
import SubtlePrism from "../../../assets/images/subtle-prism.svg";
import LoginForm from "../../forms/LoginForm";

const Login = () => {
  return (
    <div
      className="width-full height-full flex-columns flex-align-center"
      style={{ backgroundImage: `url(${SubtlePrism})` }}
    >
      <Link to="/login">
        <img className="mt-32 mb-16 height-20" src={Logo} alt="Logo" />
      </Link>
      <LoginForm />
    </div>
  );
};

export default Login;
